import { NsCard } from 'components/common/ns-card/NsCard';
import { NsContent } from 'components/common/ns-content/NsContent';

export const emailCaptureRightSidebarTestId = 'emailCaptureRightSidebarTestId';

export const EmailCaptureRightSidebar = () => {
  return(
    <NsContent data-testid={emailCaptureRightSidebarTestId}>
      <NsCard
        heading="Refer a friend and share up to £100"
        decoration="multiplePeople"
      >
        Recommend a friend to join us, and you both could get an Amazon Gift
        Card worth up to £50 (that&apos;s £100 between you!)
      </NsCard>
    </NsContent>
  )
}

export default EmailCaptureRightSidebar;
